import { Box, Grid, Typography, useMediaQuery, Theme } from '@mui/material';
import { useEffect, useState } from 'react';
import { MuiButton } from '@/components';
import { FormikConfig } from './formik';
import { useTranslation } from 'next-i18next';
import { forgotPassword, resetPasswordView } from '@/store/actions';
import { useDispatch, useSelector } from 'react-redux';
import { authSelector, intermitenceSelector } from '@/store/selectors';
import { useRouter } from 'next/router';
import { UseFirstRender } from '@/hooks';
import MuiTextField3 from '@/components/TextField3';
import { palette } from '@/theme/constants';

export const Forgot = () => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const router = useRouter();
  const { code, email } = router.query;
  const isMobile = useMediaQuery((theme: Theme) => theme.breakpoints.down('md'));
  const [showOTP, setShowOTP] = useState(false);
  const [token, setToken]: any = useState('');
  const { loading } = useSelector(intermitenceSelector);
  const authData = useSelector(authSelector);

  const handleSubmit = (data: any) => {
    // console.log('data', data);
    dispatch(forgotPassword(data));
  };

  const handleOnTouched = (key: string) => setTouched({ ...touched, [key]: true });

  const {
    values,
    handleSubmit: formikSubmit,
    handleChange,
    errors,
    touched,
    setTouched,
    dirty,
    isValid,
  } = FormikConfig(handleSubmit);

  const changeInputStatus = (value: string, error: any) => {
    if (value !== '') {
      if (error) return 'error';
      return 'inherit';
    }
    return 'inherit';
  };

  useEffect(() => {
    if (authData?.recover?.message?.toLowerCase()?.includes('email')) setShowOTP(true);
    if (!authData?.recover) setShowOTP(false);
  }, [authData?.recover]);

  UseFirstRender(() => {
    dispatch(resetPasswordView());
  }, [dispatch]);

  return (
    <>
      {!showOTP ? (
        <Box width={'100%'} display={'flex'} justifyContent={'center'} flexDirection={'column'} alignItems={'center'}>
          <Typography marginBottom={'1.25rem'} color='#1D1D1D' fontSize={'1.5rem'} fontWeight={'400'}>
            {t('you_forgot_password')}
          </Typography>

          <Typography marginBottom={'1.25rem'} px={'1.25rem'} color='#1D1D1D' align='center' fontSize={'1rem'}>
            {t('enter_email')}
          </Typography>

          <Box width={'100%'}>
            <form onSubmit={formikSubmit}>
              <Grid container width={'100%'} marginBottom={'0.5rem'} rowSpacing={2}>
                <Grid item xs={12}>
                  <Typography align='left' color={palette?.background} mb={'0.5rem'} fontSize={'1rem'}>
                    Email Address
                  </Typography>
                  <MuiTextField3
                    id='email'
                    name='email'
                    fullWidth
                    onBlur={() => {
                      handleOnTouched('email');
                    }}
                    status={changeInputStatus(values.email, errors.email && touched.email)}
                    onChange={handleChange}
                    value={values.email}
                    autoComplete='email'
                    placeholder={t('email')}
                    errorMessage={errors.email}
                  />
                </Grid>

                <Grid item xs={12}>
                  <MuiButton
                    type='submit'
                    disabled={!isValid || !dirty}
                    variant={'contained'}
                    sx={{
                      '&:disabled': {
                        backgroundColor: '#B0B3C0',
                        color: '#FFFFFF',
                        opacity: 1,
                      },
                      height: '60px',
                      borderRadius: '0.6rem',
                      fontSize: '1rem',
                      backgroundColor: !isValid ? '#B0B3C0' : '#212D6D',
                      mt: 2,
                    }}>
                    <Typography variant='button'>{t('send_email')}</Typography>
                  </MuiButton>
                </Grid>
              </Grid>
            </form>
          </Box>
        </Box>
      ) : (
        <Box width={'100%'} display={'flex'} justifyContent={'center'} flexDirection={'column'} alignItems={'center'}>
          <Typography marginBottom={'1rem'} lineHeight={2} color='#1D1D1D' fontSize={'2rem'} fontWeight={'400'}>
            Check your email.
          </Typography>

          <Typography
            marginBottom={'1rem'}
            color='#000'
            textAlign={'center'}
            // width={'0%'}
            lineHeight={1.5}
            fontSize={'1.2rem'}>
            Tap the link that we sent to <strong> {values?.email}</strong>.
          </Typography>

          <Typography color='#5C6372' fontSize={'0.688rem'}>
            Didn’t get the link?{' '}
            <a
              style={{ cursor: 'pointer', textDecoration: 'underline' }}
              onClick={() => {
                handleSubmit({ email: values?.email });
              }}>
              Resend the email
            </a>
          </Typography>
        </Box>
      )}
    </>
  );
};
